//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {

    name: 'ProfileFavList',

    props: {
        favoriteCart: {
        }
    },

    methods: {

        removeItemFrom(company) {
            this.$store.dispatch("search/removeFromFavorites", company);
        },

        addToCart(company) {
            this.$store.dispatch("search/addItem", company);
        },

        openNewTab(url) {
            window.open(url, '_blank')
        },
    },

}

